// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SUAL42zX4gzGGG {
  display: flex;
  column-gap: var(--ds-space-100, 8px);
}
.SUAL42zX4gzGGG.wcIA7l2IpAvdvv {
  margin: var(--ds-space-0, 0px) var(--ds-space-150, 12px);
}
.C0giQIGPclJtQ0 {
  display: flex;
  overflow-y: auto;
  column-gap: var(--ds-space-100, 8px);
  scrollbar-width: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SUAL42zX4gzGGG`,
	"panel": `wcIA7l2IpAvdvv`,
	"buttons": `C0giQIGPclJtQ0`
};
export default ___CSS_LOADER_EXPORT___;
